import api from "../api-request";

// 获取文件预览地址
function getFileId(params) {
  return api.get("/marketing-tool/radar/link/fileId", { params });
}

// 获取企微活码
function getWxLink(params) {
  return api.get("/marketing-tool/radar/link/inviteCode", { params });
}

// 页面浏览计时接口
function callTime(params) {
  return api.get("/marketing-tool/radar/link/callTime", { params });
}

// 下载通知
function notice(params) {
  return api.post("/marketing-tool/radar/link/notice", params);
}

//获取wx配置参数
function autograph(params) {
  return api.get("/wx/js/autograph", { params });
}

//匿名访客补充营销素材信息
function supPlementInfo(params) {
  return api.post("/marketing-tool/radar/supplement/info", params);
}


//获取wx配置参数
function autographThird(params) {
  return api.get("/traffic/wx/chat/empower/chat/getJsAgentConfig", { params });
}

export default {
  getFileId,
  getWxLink,
  callTime,
  notice,
  autograph,
  supPlementInfo,
  autographThird
};
